import { Table as AntdTable } from 'antd';
import { Skeleton } from '../index';
import styles from './index.module.scss';

const TableSkeleton = ({ columns, rowCount, size }) => {
  return (
    <AntdTable
      rowKey="key"
      pagination={false}
      size={size}
      dataSource={[...Array(rowCount)].map((_, index) => ({
        key: `key${index}`,
      }))}
      columns={(() => {
        const renderColumns = (cols) =>
          cols.map((column) => {
            if (column.children) {
              return {
                ...column,
                title: typeof column?.title === 'string' ? column?.title?.toUpperCase() : column?.title,
                children: renderColumns(column.children),
              };
            }
            return {
              ...column,
              title: typeof column?.title === 'string' ? column?.title?.toUpperCase() : column?.title,
              render: () => {
                return <Skeleton height={32} />;
              },
            };
          });
        return renderColumns(columns);
      })()}
      className={styles.SkeletonTable}
    />
  );
};

export default TableSkeleton;
